import MaterialTable from "@material-table/core";
import { useEffect, useState } from "react";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import { useUserInfo } from "../../common/user-context";
import { log } from "../../Helper";
import {currencyPayload} from "./../utility/constants"
import {sortByPriceWithCurrency} from "../../utils/utils"

function QuoteResultDetailPanel(props) {

  const {userData} = useUserInfo();
  const authorities = userData.authorities;
  const [isLoading, setIsLoading] = useState(false);
  const { rowData, getTableData } = props;
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    var quoteList = [];
    var lostProviderResults = rowData['losers'];
    if(null != lostProviderResults && undefined != lostProviderResults){
        for (let i = 0; i < lostProviderResults.length; i++) {
        var quote = {
            expectedTimeframe:"",
            pickupDays:"",
            amount:"",
            providerDescr:"",
            quoteId:"",
            orderPathId:"",
            submittedQuoteId:"",
            orderNumber:"",
            currency:"",
            orderUnit:"",
            comar:""
        };
        quote.providerDescr = lostProviderResults[i].providerDescr;
        quote.amount = parseFloat(lostProviderResults[i].amount) + currencyPayload[lostProviderResults[i].currency] ;
        quote.expectedTimeframe = lostProviderResults[i].expectedTimeframe + "(" + "+" +lostProviderResults[i].pickupDays +")";
        quote.submittedQuoteId = lostProviderResults[i].submittedQuoteId;
        quote.quoteId = lostProviderResults[i].quoteId;
        quote.orderPathId = rowData.orderPathId;
        quote.orderNumber = lostProviderResults[i].orderNumber;
        quote.orderUnit = lostProviderResults[i].orderUnit;
        quote.comar = lostProviderResults[i].orderUnit + lostProviderResults[i].orderNumber;

        quoteList.push(quote);
        }
    }

    const sortedQuoteList = () =>
      quoteList.sort(function (a, b) {
        return sortByPriceWithCurrency(a.amount,b.amount)
      });
    setTableData(sortedQuoteList);
  }, [rowData]);
  
  const columns = [
    {
        title: "Comar",
        field: "comar",
        sorting: true,
        hidden: false,
        headerStyle: {
            fontSize: "12px",
        }
      },
      {
        title: "Expected Pickup",
        field: "expectedTimeframe",
        sorting: true,
        hidden: false,
        headerStyle: {
          fontSize: "12px",
        },     
     },
     {
      title: "Provider(Lost)",
      field: "providerDescr",
      sorting: true,
      hidden: false,
      headerStyle: {
        fontSize: "12px",
      }
     },
      {
        title: "Amount",
        field: "amount",
        sorting: true,
        hidden: false,
        headerStyle: {
            fontSize: "12px",
        },
        customSort: (a,b) =>{
          return sortByPriceWithCurrency(a.amount,b.amount);
         },
         padding:"3px",
      },
      {
          title: "Order Path Id",
          field: "freeorderPathIdText",
          sorting: true,
          hidden: true,
          headerStyle: {
              fontSize: "12px",
          },
      },
    {
      title: "SubmittedId",
      field: "submittedId",
      sorting: true,
      hidden: true,
      headerStyle: {
          fontSize: "12px",
      },
    },
    {
      title: "QuoteId",
      field: "quoteId",
      sorting: true,
      hidden: true,
      headerStyle: {
          fontSize: "12px",
      },
    }
];

  return (
    <>
      {isLoading && <LoaderComponent />}
      <div className="flex flex-col p-2 mr-40 ml-40">
          <MaterialTable
              columns={columns}
              localization={{
                  body: {
                      emptyDataSourceMessage: (
                          <h7 className="text-center">
                              No records to display
                          </h7>
                      ),
                  },
                  pagination: {
                      labelRowsPerPage: "Orders Per Page",
                      labelRowsSelect: "Orders",
                  },
              }}
              options={{
                  rowStyle: {
                      fontSize: 10
                  },
                  draggable: false,
                  selection: false,
                  toolbar:false,
                  search: false,
                  showTitle: false,
                  grouping: false,
                  paging:false,
                  filtering: false,
                  padding : 0,
                  actionsColumnIndex: -1,
                  headerStyle: {
                      backgroundColor: "#99bd93",
                      fontWeight: "400",
                      color: "white",
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                      height: "60px"
                  },
                  tableContainerStyle: {
                      overflow: "auto",
                  },
                  filterCellStyle: {
                      flex: 1
                  },
              }}
              title={"Internal Quote Results"}
              data={tableData}    
          />
      </div>
    </>
  );
}
export default QuoteResultDetailPanel;
